// Pure announcement model for the global "Search iYuga" results dropdown.
//
// MEASURED GAP (web-stg, bundle main.1d538a78.js, 2026-07-28): the live search
// dropdown contains ZERO live regions —
//   listbox.querySelectorAll('[aria-live],[role=status],[role=alert]') => []
// so a screen-reader user who types a query is told nothing: not how many
// results arrived, and not that there were none ("No Users Found" is painted
// silently). The only live regions on the page belong to the SPA RouteAnnouncer,
// which is a different component and must not be reused for this.
//
// This module decides ONLY the string to place in the SearchBar's own polite
// live region. The component owns the DOM. Kept pure so the wording and the
// (easy to get wrong) singular/plural + precedence rules are unit-testable
// rather than only live-QA-able.
//
// Precedence, highest first:
//   1. a failed search  -> "" (the error message already renders with
//      role="alert", which announces itself; a second polite copy would make
//      screen readers say it twice)
//   2. in-flight        -> "Searching…"
//   3. no query at all  -> "" (nothing to say; also clears the region so the
//      NEXT identical result count is re-announced rather than deduped away)
//   4. zero results     -> "No users found." / "No wheels found." /
//                          "No collections found."
//   5. N results        -> "N user(s) found." / "N wheel(s) found."

// #920 §5: Collections joins Users/Wheels as a searchable tab.
const NOUN = {
  Users: ["user", "users"],
  Wheels: ["wheel", "wheels"],
  Collections: ["collection", "collections"],
};

export function searchAnnouncement({
  loading,
  fetchError,
  searchText,
  selectedTab,
  count,
}) {
  // 1. The role="alert" error owns this case.
  if (fetchError) return "";

  // 3. No query => nothing to announce. Checked before `loading` so a cleared
  //    box never leaves a stale "Searching…" hanging in the live region.
  const query = typeof searchText === "string" ? searchText.trim() : "";
  if (!query) return "";

  // 2. In flight.
  if (loading) return "Searching…";

  const [singular, plural] = NOUN[selectedTab] || NOUN.Users;
  const n = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;

  // 4. Empty.
  if (n === 0) return `No ${plural} found.`;

  // 5. Populated.
  return `${n} ${n === 1 ? singular : plural} found.`;
}
